<div class="dashboard-container">
  <div class="dashboard-cards">

    <div *ngIf="mimesysAvailable" class="dashboard-card-col">
      <hbo-dashboard-card
        [ctaText]="'COMMON.VIEW_RESULT' | translate"
        [headerColor]="cardSettings?.card?.headerColor"
        [outlineColor]="cardSettings?.card?.outlineColor"
        [headerLogoImage]="cardSettings?.card?.mimesys?.headerLogoImage"
        [bodyImage]="cardSettings?.card?.mimesys?.bodyImage"
        (actionClick)="goToGazeMaps()">
      </hbo-dashboard-card>
    </div>

    <div *ngIf="fitAvailable" class="dashboard-card-col">
      <hbo-dashboard-card
        [ctaText]="'COMMON.VIEW_RESULT' | translate"
        [headerColor]="cardSettings?.card?.headerColor"
        [outlineColor]="cardSettings?.card?.outlineColor"
        [headerLogoImage]="cardSettings?.card?.fit?.headerLogoImage"
        [bodyImage]="cardSettings?.card?.fit?.bodyImage"
        (actionClick)="goToFits()">
      </hbo-dashboard-card>
    </div>

    <div *ngIf="depict360Available" class="dashboard-card-col">
      <hbo-dashboard-card
        [ctaText]="'FIT.3D' | translate"
        [headerColor]="cardSettings?.card?.headerColor"
        [outlineColor]="cardSettings?.card?.outlineColor"
        [headerLogoImage]="cardSettings?.card?.depict360?.headerLogoImage"
        [bodyImage]="cardSettings?.card?.depict360?.bodyImage"
        [secondCtaText]="firstFrozenTech ? ('FIT.3D_EXAMPLES' | translate) : ''"
        (actionClick)="open360Depict()"
        (secondActionClick)="open360DepictFrozen()">
      </hbo-dashboard-card>
    </div>

  </div>
</div>
